module.exports = __webpack_public_path__ + "img/Tutorial.87d4bcfd.svg";